import { CarrierType, CarrierVisitDirection, CarrierVisitStatus } from '@planning/app/api'
import { OrderNavigationDirection } from '@planning/hooks/useOrderNavigation'
import { PATHS } from '@tom-ui/utils'

export const getPathOfCarrierType = (carrierVisitType: CarrierType) =>
  carrierVisitType === CarrierType.Vessel
    ? PATHS.visits.vesselVisits.url
    : PATHS.visits.railVisits.url

export const getVisitOrderPagePath = (
  carrierVisitType: CarrierType,
  carrierVisitId: number,
  direction: OrderNavigationDirection,
  orderId: number | string,
) => `${getVisitOrderPageReturnPath(carrierVisitType, direction, carrierVisitId)}/order/${orderId}`

export const getJourneyOrderPagePath = (orderId: number | string) =>
  `${PATHS.visits.containerVisits.url}/order/${orderId}`

export const getCheckoutContainerPagePath = (
  carrierVisitType: CarrierType,
  carrierVisitId: number,
  orderId: number,
) => `${getPathOfCarrierType(carrierVisitType)}/${carrierVisitId}/checkout/${orderId}`

export const getCheckinContainerPagePath = (
  carrierVisitType: CarrierType,
  carrierVisitId: number,
  orderId: number,
) => `${getPathOfCarrierType(carrierVisitType)}/${carrierVisitId}/checkin/${orderId}`

export const getVisitOrderPageReturnPath = (
  carrierVisitType: CarrierType,
  direction: OrderNavigationDirection,
  carrierVisitId: number,
) => `${getPathOfCarrierType(carrierVisitType)}/${carrierVisitId}/${direction}`

export const orderDirectionToOrderNavigationDirection = (
  visitDirection: CarrierVisitDirection,
): OrderNavigationDirection => {
  switch (visitDirection) {
    case CarrierVisitDirection.Inbound:
      return 'discharge'
    case CarrierVisitDirection.Outbound:
      return 'load'
    default:
      return 'discharge'
  }
}

export const isVisitStatusBlocked = (status: CarrierVisitStatus) => {
  const blockedStatuses: CarrierVisitStatus[] = [
    CarrierVisitStatus.Closed,
    CarrierVisitStatus.Cancelled,
    CarrierVisitStatus.Completed,
    CarrierVisitStatus.Departed,
  ]

  return blockedStatuses.includes(status)
}
